import { useQueries } from "@tanstack/react-query";

import { getFarmOrganicFertilizerProduction } from "services";

import { GET_FARM_ORGANIC_FERTILIZER_PRODUCTION } from "consts";

import { FarmOrganicFertilizerProductionEntry } from "models";

export const useGetFarmOrganicFertilizerProductionByYear = ({ farmId, years }: { farmId: string; years: number[] }) =>
  useQueries({
    queries: years.map((year) => ({
      queryKey: [GET_FARM_ORGANIC_FERTILIZER_PRODUCTION, farmId, year],
      queryFn: () => getFarmOrganicFertilizerProduction({ farmId: farmId!, year }),
      select: (data: FarmOrganicFertilizerProductionEntry[]) => ({ year, productions: data }),
      enabled: !!farmId && !!year,
      staleTime: 0,
    })),
    combine: (results) => ({
      productionsByYear: Object.fromEntries(results.filter((r) => r.data != null).map((r) => [r.data!.year, r.data!.productions])),
    }),
  });
